import { EmperorUISelectFormChoice } from '@boldpenguin/emperor-form-fields';
import { IChoice } from '@boldpenguin/sdk';

export const convertChoicesToGenericChoiceType = (
  choices: IChoice[],
  useAlias = false,
  answerId?: string,
): EmperorUISelectFormChoice[] =>
  choices.map(choice => ({
    id: answerId ? `${answerId}_${choice.id}` : choice.id,
    label: !useAlias ? choice.value : choice.alias,
    value: choice.id,
  }));
